import { render, staticRenderFns } from "./CredentialCopyStorageSave.vue?vue&type=template&id=8df558d8&scoped=true&"
import script from "./CredentialCopyStorageSave.vue?vue&type=script&lang=js&"
export * from "./CredentialCopyStorageSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df558d8",
  null
  
)

export default component.exports